import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    this.updateTotals()
  }

  remove() {
    this.element.remove()
    this.updateTotals()
  }

  updateTotals() {
    const invoicesForm = document.getElementById('invoices-form')

    invoicesForm?.['invoices-form']?.updateTotals()
  }
}
